module.exports = __webpack_public_path__ + "a768e7de/img/archive-icon.0a6a9de3.svg";